<template>
  <div class="register-wrap">
    <div class="register-box w1200">
      <div class="register-type">
        <span class="register-type-item" :class="[registerType == 0 ? 'register-type-sel' : '']"
          @click="registerType = 0">用户注册</span>
        <span class="register-type-item" :class="[registerType == 1 ? 'register-type-sel' : '']"
          @click="registerType = 1">供应商入驻</span>
      </div>
      <div class="login-type" v-if="registerType == 0 && !binding">
        <div class="login-type-item fs16 fwn" :class="[method == 0 ? 'login-type-sel' : '']" @click="method = 0">微信注册
        </div>
        <div class="login-type-item fs16 fwn" :class="[method == 1 ? 'login-type-sel' : '']" @click="method = 1">短信注册
        </div>
      </div>
      <template v-if="registerType == 0">
        <div class="login-wx" v-if="method == 0">
          <div class="login-wx-code">
            <img class="login-qr-code" :src="qrcode" alt="">
            <div class="border"></div>
            <div class="border"></div>
            <div class="border"></div>
            <div class="border"></div>
          </div>
          <p class="tip">微信扫码，及时获得订单信息及优惠活动</p>
        </div>

        <div class="register-type-1" v-if="method == 1">
          <div class="register-form">
            <div class="register-form-item">
              <span class="form-name">名称</span>
              <input type="text" name="name" class="form-val" placeholder="请填写名称" v-model="form.name">
            </div>
            <div class="register-form-item">
              <span class="form-name">密码</span>
              <input type="password" name="password" class="form-val" placeholder="密码6-16个字符组成，区分大小写"
                v-model="form.password">
            </div>
            <div class="register-form-item">
              <span class="form-name">手机号</span>
              <input type="text" name="phone" class="form-val" placeholder="请填写注册手机号" v-model="form.phone">
            </div>
            <div class="register-form-item">
              <span class="form-name">验证码</span>
              <div class="code-inp">
                <input type="text" name="code" class="form-val form-val-code" placeholder="请填写验证码" v-model="form.code">
                <div class="send-code-btn flex-cc" @click="sendCode">
                  {{ text }}
                </div>
              </div>
            </div>
          </div>
          <div class="agreement">
            <input type="radio" v-model="form.agree" id="agree" value="1" /><label>我已同意<a
                @click="handleShowAgreementForm('register')">《元素魔方注册协议》</a>和<a
                @click="handleShowAgreementForm('secret')">《元素魔方隐私政策》</a></label>
          </div>
          <el-button class="register-btn flex-cc" @click="handleSubmit" :loading="loading">立即{{ binding ? '绑定' :
          '注册' }}</el-button>
          <div class="login-entry">
            已有帐号，<router-link :to="{ path: '/auth/login' }">马上登陆</router-link> ＞
          </div>
        </div>
      </template>

      <div class="register-type-2" v-if="registerType == 1">
        <div class="register-form">
          <div class="register-form-item">
            <span class="form-name">名称</span>
            <input type="text" name="name" class="form-val" placeholder="请填写名称" v-model="form.name">
          </div>
          <div class="register-form-item">
            <span class="form-name">密码</span>
            <input type="password" name="password" class="form-val" placeholder="密码6 - 16个字符组成，区分大小写"
              v-model="form.password">
          </div>
          <div class="register-form-item">
            <span class="form-name">手机号</span>
            <input type="text" name="phone" class="form-val" placeholder="请填写注册手机号" v-model="form.phone">
          </div>
          <div class="register-form-item">
            <span class="form-name">验证码</span>
            <div class="code-inp">
              <input type="text" name="code" class="form-val form-val-code" placeholder="请填写验证码" v-model="form.code">
              <div class="send-code-btn flex-cc" @click="sendCode">
                {{ text }}
              </div>
            </div>
          </div>
          <div class="register-form-item">
            <span class="form-name">单位</span>
            <input type="text" name="company" class="form-val" placeholder="单位名称" v-model="form.company">
          </div>
          <div class="register-form-item">
            <span class="form-name">申请</span>
            <div class="job-type-checkbox">
              <div class="job-type-checkbox-item form-check">
                <input type="checkbox" id="test" value="2" v-model="form.type">
                <label for="test">申请成为测试工程师</label>
              </div>
              <div class="job-type-checkbox-item form-check">
                <input type="checkbox" id="analog" value="1" v-model="form.type">
                <label for="analog">申请成为模拟计算工程师</label>
              </div>
            </div>
          </div>
        </div>
        <div class="agreement">
          <input type="radio" v-model="form.agree" id="agree" value="1" /><label for="agree">我已同意<a
              @click="handleShowAgreementForm('supplier_cooperate')">《元素魔方供应商合作协议》</a>和<a
              @click="handleShowAgreementForm('supplier_secret')">《供应商隐私政策》</a></label>
        </div>
        <el-button class="register-btn flex-cc" :loading="loading" @click="handleApply">申请入驻</el-button>
        <div class="login-entry">
          已有帐号，<a target="_blank" href="/supplier/">马上登陆</a> ＞
        </div>
      </div>
    </div>
    <!-- 滑动验证码 -->
    <Verify ref="verify" @success="captchaSuccess" mode="pop" :captchaType="form.captchaType"
      :imgSize="{ width: '330px', height: '155px' }"></Verify>
    <!-- 协议 -->
    <Agreement :alias="agreementType" :visible.sync="showAgreementForm" @agree="agree"></Agreement>
  </div>
</template>
<script>

import { getWeixinQrcode, checkByWeixinQrcode, register } from "@/api/auth";
import { apply } from "@/api/supplier";
import { sendCode } from "@/api/common";
import { validatePhone } from "@/utils/validate";
import { getStorage } from "@/utils/auth";
import { v4 as uuidv4 } from 'uuid';
//引入组件
import Verify from "@/components/verifition/Verify";
//引入组件
import Agreement from "@/components/agreement";
export default {
  name: "AuthRegister",
  components: {
    Verify,
    Agreement
  },
  data() {
    return {
      registerType: 0,
      method: 0,
      loading: false,
      disabled: false,
      countdown: 60,
      text: "发送验证码",
      config: {},
      form: {
        agree: '',
        type: [],
        phone: getStorage("loginPhone") || '',
        password: '',
        code: '',
        captchaType: "blockPuzzle",
        captchaVerification: "",
        csrf: "",
        openid: "",
        alias: getStorage('alias') || ''
      },
      //0登录1发送验证码
      method: 0,
      qrcode: null,
      timer: null,
      checkQrcodeTimer: null,
      binding: false,
      agreementType: '',
      showAgreementForm: false,
    };
  },
  created() {
    this.registerType = this.$route.query.type || 0;
    this.getWeixinQrcode()
  },
  methods: {
    handleShowAgreementForm(type) {
      this.agreementType = type;
      this.showAgreementForm = true;
    },
    agree(res) {
      this.form.agree = res;
    },
    getWeixinQrcode() {
      const that = this
      that.uuid = uuidv4();
      getWeixinQrcode({ uuid: this.uuid }).then((res) => {
        that.qrcode = res.data
        that.checkQrcodeTimer = setInterval(() => {
          that.checkByWeixinQrcode()
        }, 3000)
      }).catch((err) => {

      })
    },
    checkByWeixinQrcode() {
      checkByWeixinQrcode({ uuid: this.uuid }).then((res) => {
        if (res.data.scan == 1) {
          clearInterval(this.checkQrcodeTimer)
          if (res.data.user_id) {
            this.$message.error('该微信号已绑定其他账号，请直接登录！')
            return
          }
          this.$message.error('请绑定账号！')
          this.binding = true;
          this.form.openid = res.data.openid
          this.method = 1;
        } else {
          console.log('扫码失败！')
        }
      }).catch((err) => {

      })
    },
    sendCode() {
      const that = this
      const _form = that.form;
      if (that.disabled) return
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      console.log(_form)
      if (!_form.captchaVerification) {
        that.method = 1;
        this.$refs.verify.show()
        return;
      }
      that.disabled = true
      sendCode(that.form).then((res) => {
        that.timer = setInterval(() => {
          that.countdown--
          this.text = "重新发送(" + that.countdown + "s)"
          if (that.countdown == 0) {
            that.disabled = false
            that.text = '发送验证码'
            that.countdown = 60
            clearInterval(that.timer)
          }
        }, 1000)

        if (res.code == 0) {
          this.form.csrf = res.data.csrf
          this.$message({
            type: 'success',
            message: '短信发送成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    captchaSuccess(params) {
      console.log(params);
      this.form = {
        ...this.form,
        ...params,
      }
      this.sendCode()
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },
    //提交注册请求
    handleSubmit() {
      const that = this;
      const _form = this.form;
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      if (!_form.password) {
        this.$message({
          type: 'error',
          message: '请输入密码'
        });
        return;
      }
      if (!_form.code) {
        this.$message({
          type: 'error',
          message: '请输入验证码'
        });
        return;
      }
      if (!_form.agree) {
        this.$message({
          type: 'error',
          message: '请阅读注册协议'
        });
        return;
      }
      this.loading = true;
      register(_form).then(res => {
        this.loading = false;
        this.form.csrf = '';
        this.$message.success('注册成功，请登录！')
        this.$router.push('/auth/login')
      }).catch(() => {
        this.loading = false;
      });
    },

    //提交注册请求
    handleApply() {
      const that = this;
      const _form = this.form;
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      if (!_form.name) {
        this.$message({
          type: 'error',
          message: '请输入名称'
        });
        return;
      }
      if (!_form.password) {
        this.$message({
          type: 'error',
          message: '请输入密码'
        });
        return;
      }
      if (!_form.code) {
        this.$message({
          type: 'error',
          message: '请输入验证码'
        });
        return;
      }
      if (!_form.company) {
        this.$message({
          type: 'error',
          message: '请输入所在单位'
        });
        return;
      }
      if (_form.type.length == 0) {
        this.$message({
          type: 'error',
          message: '请选择申请类型'
        });
        return;
      }
      if (!_form.agree) {
        this.$message({
          type: 'error',
          message: '请阅读注册协议'
        });
        return;
      }
      this.loading = true;
      apply(_form).then(res => {
        this.loading = false;
        this.form.csrf = '';
        this.$message.success('提交成功，请等待工作人员与您联系！')
      }).catch(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/login.less';
</style>
